module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "discoverPage"
  }, [_c('div', [_c('div', [_c('p', [_c('strong', [_vm._v("Explore book giveaways, sneak peeks, deals, and more.")])]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "landingPageLink",
    attrs: {
      "href": "https://discover.hachettebookgroup.com/?ref=9780446509954&discp=0",
      "target": "_blank"
    }
  }, [_vm._v("Tap here to learn more")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherLogo"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "publisherLogoImg",
    attrs: {
      "alt": "Grand Central Publishing logo",
      "src": "images/publisher-logo.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38ffb352","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/discover-page_pre.vue
// module id = 72
// module chunks = 0